import React from 'react';
import PropTypes from 'prop-types';
import {SearchIcon as SearchImg} from '../../Icons';
import {Image} from '@learningblocks/shared-components/lib/Image';
import style from './style.module.scss';

/**
 * SearchIcon
 *   - The search icon image.
 */
export function SearchIcon(props) {
  return (
    <span
      className={style.searchbox_icon}
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          props.onClick();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Search glossary"
    >
      <Image src={SearchImg} alt='' />
    </span>
  );
}

SearchIcon.propTypes = {
  /**
   * Callback function to execute when search button is clicked.
   */
  onClick: PropTypes.func.isRequired,
};

SearchIcon.defaultProps = {};
